// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-80[data-v-f863c0a0] {\n  width: 80%;\n}\n.active[data-v-f863c0a0] {\n  color: var(--projectal-orange);\n}\n.min-width-120[data-v-f863c0a0] {\n  min-width: 120px;\n}\n.min-height-17[data-v-f863c0a0] {\n  min-height: 17px;\n}\n.gantt-import-mapper-header-container[data-v-f863c0a0] {\n  height: 49px;\n}\n", ""]);
// Exports
module.exports = exports;
